import React, { useState, useEffect } from 'react';
import { Switch } from '@headlessui/react';

const MinigameCartSetting = ({ data, onSave }) => {
    const [settings, setSettings] = useState([]);

    useEffect(() => {
        if (data) {
            setSettings(data);
        }
    }, [data]);

    const handleSortOrderChange = (index, value) => {
        const newSettings = [...settings];
        newSettings[index] = {
            ...newSettings[index],
            sortOrder: parseInt(value) || 0
        };
        setSettings(newSettings);
    };

    const handleUseYnChange = (index, checked) => {
        const newSettings = [...settings];
        newSettings[index] = {
            ...newSettings[index],
            useYn: checked ? 1 : 0
        };
        setSettings(newSettings);
    };

    const handleSave = () => {
        if (onSave) {
            onSave(settings);
        }
    };

    return (
        <div className="p-4">
            <div className="grid grid-cols-4 gap-4 mb-4 text-sm">
                <div className="font-bold">순서</div>
                <div className="font-bold">게임 종류</div>
                <div className="font-bold">베팅 항목</div>
                <div className="font-bold">사용 여부</div>
            </div>
            <div className="space-y-2">
                {settings.map((item, index) => (
                    <div key={index} className="grid grid-cols-4 gap-4 items-center text-sm">
                        <div>
                            <input
                                type="number"
                                className="w-full p-2 border rounded text-center"
                                value={item.sortOrder || 0}
                                onChange={(e) => handleSortOrderChange(index, e.target.value)}
                            />
                        </div>
                        <div className="text-gray-600">{item.gameName}</div>
                        <div>{item.holeTypeNm}</div>
                        <div className="flex justify-center">
                            <Switch
                                checked={item.useYn === 1}
                                onChange={(checked) => handleUseYnChange(index, checked)}
                                className={`${
                                    item.useYn === 1 ? 'bg-blue-600' : 'bg-gray-200'
                                } relative inline-flex h-6 w-11 items-center rounded-full transition-colors focus:outline-none`}
                            >
                                <span
                                    className={`${
                                        item.useYn === 1 ? 'translate-x-6' : 'translate-x-1'
                                    } inline-block h-4 w-4 transform rounded-full bg-white transition-transform`}
                                />
                            </Switch>
                        </div>
                    </div>
                ))}
            </div>
            <div className="flex justify-center mt-6 gap-2">
                <button
                    onClick={handleSave}
                    className="bg-blue-500 text-white px-4 py-2 rounded text-sm"
                >
                    저장
                </button>
            </div>
        </div>
    );
};

export default MinigameCartSetting;